import { getWebComponentInstance } from 'fg-frontend/src/webComponents/decorate';

export default (props, e) => {
	e.preventDefault();
	const searchForm = document.querySelector('[data-is="SearchForm"]');
	const searchFormComponentElement = document.getElementById(searchForm.id);
	let searchFormComponent = getWebComponentInstance(searchFormComponentElement);
	searchFormComponent.cancelFormData();
};



// WEBPACK FOOTER //
// ./fe/web-default/src/js/webActions/cancelSearchForm.js